import PortalIdParser from 'PortalIdParser';
import { BYTES_IN_MEGABYTE, FILESIZE_UNITS, FileTypes } from '../constants';
import { TypeToExtensions } from '../constants/fileTypes';
import { FileMetaAccessTypes } from '../constants/internal/FileMetaAccess';
import { isChirpFileMeta, isFMFileMeta } from '../types/internal';
export function splitNameAndExtension(fileName) {
  const parts = fileName.split('.');
  if (parts.length === 1) {
    return {
      extension: '',
      name: fileName
    };
  }
  return {
    extension: (parts.pop() || '').toLowerCase(),
    name: parts.join('.')
  };
}
export function isShutterstockImage(file) {
  var _file$extendedMetadat;
  const isFileMeta = isChirpFileMeta(file);
  const type = isFileMeta ? file.fileType : file.type;
  if (type !== FileTypes.IMG) {
    return false;
  }
  return isFileMeta ? Boolean((_file$extendedMetadat = file.extendedMetadata) === null || _file$extendedMetadat === void 0 || (_file$extendedMetadat = _file$extendedMetadat.thirdPartyIntegrations) === null || _file$extendedMetadat === void 0 ? void 0 : _file$extendedMetadat.shutterstock_id) : Boolean(file.meta.shutterstock_id);
}
const FORM_UPLOADS_FOLDER_NAME = 'form-uploads';
const getIsFileSubmittedThroughForms = url => {
  const fileUrl = url || '';
  return fileUrl.indexOf(`hubfs/${PortalIdParser.get()}/${FORM_UPLOADS_FOLDER_NAME}`) > -1;
};
const getIsFileAccessibleAnonymously = accessOrMeta => {
  if (isFMFileMeta(accessOrMeta)) {
    return accessOrMeta.allows_anonymous_access;
  }
  return accessOrMeta === FileMetaAccessTypes.PUBLIC_INDEXABLE || accessOrMeta === FileMetaAccessTypes.PUBLIC;
};
export const getIsFilePrivate = (accessOrMeta, url) => {
  return !getIsFileAccessibleAnonymously(accessOrMeta) && !getIsFileSubmittedThroughForms(url);
};
export const getIsFileSensitive = accessOrMeta => {
  if (isFMFileMeta(accessOrMeta)) {
    return accessOrMeta.sensitive;
  }
  return accessOrMeta === FileMetaAccessTypes.SENSITIVE;
};
export const getIsFileExternal = (accessOrMeta, url) => {
  return !getIsFileAccessibleAnonymously(accessOrMeta) && getIsFileSubmittedThroughForms(url);
};
export const getType = extensionOrType => {
  if (Object.prototype.hasOwnProperty.call(FileTypes, extensionOrType)) {
    return extensionOrType;
  }
  const type = Object.keys(TypeToExtensions).find(key => TypeToExtensions[key].includes(extensionOrType));
  if (type) {
    return type;
  }
  return FileTypes.OTHER;
};
export const getFileType = (type, extension) => {
  if (type && Object.values(FileTypes).includes(type)) {
    return type;
  }
  return getType(extension);
};
export const getIsImage = (type, extension) => {
  return getFileType(type, extension) === FileTypes.IMG;
};
export const getIsSvg = (type, extension, encoding) => {
  return getIsImage(type, extension) && encoding === 'svg';
};
export const getIsSvgTooLarge = size => {
  return size >= BYTES_IN_MEGABYTE;
};
export const getIsTemporaryUploadingFile = id => {
  return id <= 0;
};
export const splitFileIntoChunks = (file, chunkSize) => {
  const fileSize = file.size;
  const chunks = Math.ceil(fileSize / chunkSize);
  const fileChunks = [];
  for (let i = 0; i < chunks; i++) {
    const start = i * chunkSize;
    const end = Math.min(start + chunkSize, fileSize);
    const chunk = file.slice(start, end);
    fileChunks.push(chunk);
  }
  return fileChunks;
};
export const getFileSizeInBytes = fileSize => {
  const sizeUnits = Object.keys(FILESIZE_UNITS);
  const sizeRegex = new RegExp(`^(\\d+\\.?\\d*)\\s*(${sizeUnits.join('|')})$`, 'i');

  // if the number or unit don't match our expected format, throw an error
  const match = fileSize.match(sizeRegex);
  if (!(match !== null && match !== void 0 && match[1]) || !match[2]) {
    console.error('[getFileSizeInBytes] - fileSize does not match expected format');
    return;
  }
  const sizeValue = parseFloat(match[1]);
  const sizeUnit = match[2].toUpperCase();
  const sizeInBytes = sizeValue * Math.pow(1024, sizeUnits.indexOf(sizeUnit));
  return Math.floor(sizeInBytes);
};
export function base64ToFile(base64String, filename) {
  var _arr$;
  const arr = base64String.split(',');
  const mime = (_arr$ = arr[0]) === null || _arr$ === void 0 || (_arr$ = _arr$.match(/:(.*?);/)) === null || _arr$ === void 0 ? void 0 : _arr$[1];
  const bstr = atob(arr[1]);
  let n = bstr.length;
  const u8arr = new Uint8Array(n);
  while (n--) {
    u8arr[n] = bstr.charCodeAt(n);
  }
  return new File([u8arr], filename, {
    type: mime
  });
}